
export function getUniqueHighlights(list, cls = 'highlight') {
    const keywords = new Set();
    const group = {};

    const div = document.createElement('div');

    for (const data of list) {
        if (group[data.field] === undefined) {
            group[data.field] = { keywords: new Set(), items: [] };
        }

        for (const text of data.highlights) {
            const res = { text, keywords: new Set() };

            div.innerHTML = text;

            const highlights = div.getElementsByClassName(cls);

            for (const el of highlights) {
                const highlightText = el.innerHTML;
                res.keywords.add(highlightText);
                keywords.add(highlightText);
                group[data.field].keywords.add(highlightText);
            }

            group[data.field].items.push(res);
        }
    }

    return {
        keywords,
        group,
    };
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
function escapeHtml(unsafe) {
    return unsafe
        .replaceAll(/&/g, "&amp;")
        .replaceAll(/</g, "&lt;")
        .replaceAll(/>/g, "&gt;")
        .replaceAll(/"/g, "&quot;")
        .replaceAll(/'/g, "&#039;");
}

export function compareHighlightedSnippet(str, highlight, cls = 'highlight') {
    return str.indexOf(
        highlight.replaceAll(
            new RegExp(`<span class="${cls}">(.*?)</span>`, 'gu'),
            '$1'
        )
    ) > -1;
}


export function highlightStrKeywords(str, arrOrSet, cls = 'highlight') {
    str = escapeHtml(str);

    (arrOrSet instanceof Set ? Array.from(arrOrSet) : arrOrSet).forEach(
        keyword => {
            const rx = new RegExp(
                `(^|[^\\p{L}\\p{N}>])(${escapeRegExp(keyword)})($|[^\\p{L}\\p{N}<])`,
                'gu'
            );
            str = str.replaceAll(rx, `$1<span class="${cls}">$2</span>$3`);
        }
    );

    return str;
}

export function isStrContainKeywords(str, arr) {
    return str && (arr instanceof Set ? Array.from(arr) : arr).find(v => str.indexOf(v) > -1);
}

export function getHighlightGroupsKeywordsSet(highlights, groups) {
    return highlights && highlights.group && groups
        ? new Set(groups.map(
            v => highlights.group[v] ? [...highlights.group[v].keywords] : null
        ).filter(v => v).flat())
        : []
    ;
}
